<img class="img-thumbnail" [class.rounded-circle]="circle" [src]="src" [alt]="description" [width]="width"
  [height]="height">